import Cookies from "universal-cookie";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
const cookies = new Cookies();

var AppUtils = {
    // Helper functions
    getArrayWithId: function (a, id) {
        for (var i in a) {
            if (a[i].id === id) return a[i];
        }
        return undefined;
    },
    getCookie: function (l) {
        return cookies.get("MOES_LOBBY_" + l, { path: "/" });
    },
    saveCookie: function (lobby, code) {
        cookies.set("MOES_LOBBY_" + lobby, code, {
            path: "/",
            maxAge: 7200,
            sameSite: "None",
            secure: true,
        });
    },
    removeCookie: function (lobby) {
        cookies.remove("MOES_LOBBY_" + lobby, { path: "/" });
    },
    getLoginCookie: function () {
        return cookies.get("MOES", { path: "/" });
    },
    saveLoginCookie: function (token) {
        cookies.set("MOES", token, {
            path: "/",
            maxAge: 86400 * 14,
            sameSite: "Strict",
            secure: true,
        });
    },
    removeLoginCookie: function () {
        this.log("Removing login cookie");
        cookies.remove("MOES", { path: "/" });
        this.log("All cookies:", cookies.getAll());
    },
    getAllowCookiesCookie() {
        return cookies.get("MOES_ALLOW_COOKIES", { path: "/" });
    },
    saveAllowCookiesCookie(preferences) {
        cookies.set("MOES_ALLOW_COOKIES", preferences, {
            path: "/",
            maxAge: 365 * 24 * 60 * 60,
            secure: true,
        });
    },
    getAllCookies: function () {
        return cookies.getAll();
    },
    getRandomMoesValue: function () {
        return Date.now().toString() + "-" + Math.random();
    },
    replaceLanguage: function (str, mapObj) {
        var re = new RegExp(Object.keys(mapObj).join("|"), "gi");
        str = str.replace(re, function (matched) {
            return mapObj[matched.toLowerCase()];
        });
        return str;
    },
    vibrate: function (x) {
        if ("vibrate" in navigator) {
            navigator.vibrate(x);
        }
    },
    log: function (...args) {
        if (import.meta.env.VITE_ENABLE_LOG === "true") {
            if (typeof console !== "undefined") {
                console.log(...args);
            }
        }
    },
    post: function (url, data, onSuccess, onError, next, wholeDataOnError) {
        console.log("[AppUtils.post] Calling", url, "with data", data);
        axios
            .post(url, data, {
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                console.log("Data is:", res.data);
                console.log("Success is", res.data.success);
                if (res.data.success === true) {
                    console.log(
                        "[AppUtils.post]: API call for " + url + " succeeded.",
                        res.data.data
                    );
                    next(onSuccess(res.data.data));
                } else {
                    console.log(
                        "[AppUtils.post]: API call for " + url + " failed.",
                        res.data.error
                    );
                    if (onError !== undefined) {
                        if (wholeDataOnError === undefined) {
                            next(onError(res.data.error));
                        } else {
                            next(onError(res.data));
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(
                    "[AppUtils.post]: API call for " + url + " failed (error).",
                    error
                );
                if (onError !== undefined) {
                    if (error && error.code && error.code === "ERR_NETWORK") {
                        next(onError("Our backend is currently offline."));
                    }
                    else {
                        next(onError(error.message));
                    }
                }
            });
    },
    isMobile: function () {
        const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
        return isMobile;
    },
};

export default AppUtils;
